import { ReactNode } from "react";
import "./RequireFailoverActive.scss";
import { useTranslation } from "react-i18next";
import { useFailoverSelector } from "userful-chronos-common-store/dist/failover";
import { isDebug } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

interface IProps {
    children: ReactNode;
}

const RequireFailoverActive = ({ children }: IProps) => {
    const { t } = useTranslation();

    const failoverStatus = useFailoverSelector((state) => state.failoverStore.failoverStatus);
    if (
        isDebug() ||
        !failoverStatus ||
        (failoverStatus.statusData.status !== "passive" && failoverStatus.statusData.status !== "passive-pending")
    ) {
        return <>{children}</>;
    }

    return (
        <div className={`failoverInactive`}>
            <div className="loading">
                <div className="loadingText">
                    <h1 className="loading-main-text">{t("CommonUI.failoverInactive")}</h1>
                    <h3 className="loading-secondary-text">{t("CommonUI.failoverInactiveDesc")}</h3>
                </div>
            </div>
        </div>
    );
};

export default RequireFailoverActive;
